(() => {
  if (window.Sn81Forms) return;
  const selector = '.sn18-contact__form, .sv10-footer__form, .sn33-newsletter__form';
  const records = new Map();
  let sending = 'Envoi en cours…';
  try {
    const strings = JSON.parse(document.getElementById('sn81-ui-strings')?.textContent || '{}');
    if (typeof strings.sending === 'string' && strings.sending.trim()) sending = strings.sending;
  } catch {}

  const visibleFocusTarget = element => {
    if (!element?.isConnected || typeof element.focus !== 'function') return false;
    if (element.matches(':disabled,[aria-disabled="true"]') || element.closest('[hidden],[inert],[aria-hidden="true"],dialog:not([open])')) return false;
    if (!element.getClientRects().length) return false;
    for (let ancestor = element; ancestor; ancestor = ancestor.parentElement) {
      const style = getComputedStyle(ancestor);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  };

  const restore = (form, restoreFocus = false) => {
    const record = records.get(form);
    if (!record) return;
    records.delete(form);
    if (record.timer !== null) clearTimeout(record.timer);
    if (record.started) {
      if (record.busy === null) form.removeAttribute('aria-busy');
      else form.setAttribute('aria-busy', record.busy);
      form.classList.toggle('sn81-is-sending', record.wasSending);
      if (record.button && record.nodes) record.button.replaceChildren(...record.nodes);
    }
    if (restoreFocus) {
      const target = [record.focus, record.button].find(visibleFocusTarget);
      target?.focus({ preventScroll: true });
    }
  };

  const restoreAll = restoreFocus => {
    const forms = [...records.keys()];
    forms.forEach((form, index) => restore(form, restoreFocus && index === forms.length - 1));
  };

  const submit = event => {
    const form = event.target;
    if (!form?.matches?.(selector)) return;
    if (event.defaultPrevented) { restore(form); return; }
    if (records.has(form)) { event.preventDefault(); return; }
    if (!form.checkValidity()) return;
    const submitter = event.submitter;
    const button = submitter?.tagName === 'BUTTON' && submitter.form === form
      ? submitter
      : form.querySelector('button[type="submit"], button:not([type])');
    const record = {
      button,
      focus: form.contains(document.activeElement) ? document.activeElement : button,
      started: false,
      timer: null
    };
    records.set(form, record);
    queueMicrotask(() => {
      if (records.get(form) !== record) return;
      if (event.defaultPrevented || !form.isConnected || !form.checkValidity()) { restore(form); return; }
      record.busy = form.getAttribute('aria-busy');
      record.wasSending = form.classList.contains('sn81-is-sending');
      record.nodes = button ? [...button.childNodes] : null;
      record.started = true;
      form.setAttribute('aria-busy', 'true');
      form.classList.add('sn81-is-sending');
      if (button) button.textContent = sending;
      record.timer = setTimeout(() => restore(form), 15000);
    });
  };

  document.addEventListener('submit', submit, true);
  document.addEventListener('invalid', event => {
    const form = event.target.form || event.target.closest?.('form');
    if (form?.matches(selector)) restore(form);
  }, true);
  document.addEventListener('reset', event => {
    if (event.target?.matches?.(selector)) restore(event.target);
  });
  document.addEventListener('shopify:section:unload', event => {
    [...records.keys()].forEach(form => {
      if (event.target === form || event.target.contains?.(form)) restore(form);
    });
  });
  window.addEventListener('pageshow', () => restoreAll(true));
  window.Sn81Forms = { reset: () => restoreAll(false) };
})();
